import common from './common'
import home from './home' // wp complete
import events from './events'
import team from './team' // wp complete
import terms from './terms' // wp complete
import privacy from './privacy' // wp complete
import toronto from './toronto'
import miami from './miami'
import paris from './paris'
import montreal from './montreal'
import buenosAires from './buenosAires'
import phoenix from './phoenix'

export default {
  home,
  common,
  events,
  team,
  privacy,
  terms,
  toronto,
  miami,
  paris,
  montreal,
  buenosAires,
  phoenix
}
